import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["order-id"]
const _hoisted_2 = { class: "col-span-2 flex" }
const _hoisted_3 = { class: "w-20 h-14 mt-2" }
const _hoisted_4 = { class: "flex flex-col justify-start pt-2 text-left" }
const _hoisted_5 = {
  key: 0,
  class: "font-bold text-md"
}
const _hoisted_6 = {
  key: 1,
  class: "font-bold text-md"
}
const _hoisted_7 = { class: "font-normal text-sm" }
const _hoisted_8 = {
  key: 2,
  class: "font-normal text-sm"
}
const _hoisted_9 = { class: "flex flex-col pt-2 text-left break-all" }
const _hoisted_10 = { class: "font-normal text-sm" }
const _hoisted_11 = { class: "font-normal text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "font-normal text-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "font-normal d-flex flex-col text-sm"
}
const _hoisted_14 = { class: "font-normal d-flex gap-1 text-sm" }
const _hoisted_15 = { class: "font-normal d-flex gap-1 text-sm" }
const _hoisted_16 = {
  key: 0,
  class: "col-span-3"
}
const _hoisted_17 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 1,
  class: "col-span-3"
}
const _hoisted_22 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_23 = {
  key: 2,
  class: "col-span-3"
}
const _hoisted_24 = { class: "text-red-600 flex items-center justify-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "flex pt-4 pb-2 pl-3" }
const _hoisted_30 = { class: "text-red-500 pr-2" }
const _hoisted_31 = {
  key: 1,
  class: "flex items-center justify-between p-2"
}
const _hoisted_32 = { class: "pt-3" }

import {
  DIRECTION_DELIVERY,
  UNASSIGNED,
  licensePlateRegex,
  COUNTER_CANCELLATION_NEEDED,
} from "@/utils/constants";
import { PropType, ref } from "vue";
import ArrowBackward from "@/components/icons/ArrowBackward.vue";
import ArrowForward from "@/components/icons/ArrowForward.vue";
import ElectricLocomotive from "@/components/icons/ElectricLocomotive.vue";
import OrderDetails from "./OrderDetails.vue";
import StatusChangeButton from "@/components/StatusChangeButton.vue";
import router from "@/router";
import OrderTrainInfo from "./OrderTrainInfo.vue";
import store from "@/store";

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCard',
  props: {
  order: {
    type: Object,
    default: () => ({
      orderId: null,
      orderPosition: null,
      primaryReference: null,
      secondaryReference: null,
      directionType: null,
      transportationStatus: null,
      loading_unit_formatted: null,
      loadUnit: {
        identifierPrefix: null,
        identifierNumber: null,
        type: null,
        lengthCode: null,
        heightCode: null,
        emptyWeight: null,
        loadWeight: null,
        totalWeight: null,
        loadingStatus: null,
        dangerousGoods: false, // Set default value for boolean properties
        waste: false,
        limitedQuantity: false,
        customsGoods: false,
      },
      train: {
        trainNumber: null,
        operatorId: null,
        operatorName: null,
        shippingDate: null,
        trainClosingTime: null,
        trainArrivalTime: null,
        trainState: null,
      },
      terminal: {
        terminalId: {
          locationCode: null,
          authority: null,
        },
        terminalName: null,
      },
      freightForwarderId: null,
      freightForwarderName: null,
      licensePlate: null,
      driverId: null,
    }),
  },
  index: Number,
  activeOrder: {
    type: [Number, null] as PropType<number | null>,
    default: null,
  },
},
  emits: ["activeOrder", "refreshData"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const showTrainInfo = ref(false);

const isNotProduction = () => {
  return process.env.NODE_ENV !== "production";
};

const toggleOrder = () => {
  if (props.activeOrder == null) {
    router.push(
      `/assignments/${props.order.orderId}/${props.order.orderPosition}/${props.order.directionType}`
    );
  } else {
    router.push("/");
  }
};

const formatKg = (value: string | number) => {
  if (!value) return;
  value = parseFloat(value as string);
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " kg";
};

const licensePlateInvalid = () => {
  if (!store.state.user.data.license_plate) return true;
  return !licensePlateRegex.test(store.state.user.data.license_plate);
};

const statusChangeButtonDisabled = () => {
  if (
    props.order.roadTransportAssignmentStatus === UNASSIGNED ||
    licensePlateInvalid()
  ) {
    return true;
  }
  return false;
};

const toggleTrainInfo = () => {
  if (!isNotProduction()) return;
  showTrainInfo.value = !showTrainInfo.value;
  emit("activeOrder", showTrainInfo.value ? props.index : null);
};

return (_ctx: any,_cache: any) => {
  const _component_db_icon = _resolveComponent("db-icon")!
  const _component_MyTravel = _resolveComponent("MyTravel")!

  return (__props.activeOrder == null || __props.activeOrder == __props.index)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "orderCard bg-white w-full rounded-lg shadow-xl",
        "order-id": __props.order.orderId
      }, [
        _createElementVNode("div", {
          onClick: toggleOrder,
          class: _normalizeClass([{
        'opacity-50':
          __props.order.transportationStatus === _unref(COUNTER_CANCELLATION_NEEDED),
      }, "grid grid-cols-3 mx-2 border-b pt-2"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (__props.order?.directionType?.toLowerCase() == _unref(DIRECTION_DELIVERY))
                ? (_openBlock(), _createBlock(ArrowForward, { key: 0 }))
                : (_openBlock(), _createBlock(ArrowBackward, { key: 1 }))
            ]),
            _createElementVNode("div", _hoisted_4, [
              (__props.order?.directionType?.toLowerCase() == _unref(DIRECTION_DELIVERY))
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("order.delivery")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("order.pick_up")), 1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(__props.order.terminal.terminalName), 1),
              (isNotProduction())
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Status: " + _toDisplayString(__props.order.transportationStatus), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("order.ref")) + ": " + _toDisplayString(__props.order.primaryReference), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("order.origRef")) + ": " + _toDisplayString(__props.order.secondaryReference), 1),
            (__props.activeOrder == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(__props.order?.loadUnit?.identifierPrefix) + _toDisplayString(__props.order?.loadUnit?.identifierNumber), 1))
              : _createCommentVNode("", true),
            (__props.activeOrder == null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("order.loadWeightShort")) + ": " + _toDisplayString(formatKg(__props.order?.loadUnit?.loadWeight)), 1),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("order.emptyWeightShort")) + ": " + _toDisplayString(formatKg(__props.order?.loadUnit?.emptyWeight)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (
          __props.order.loadUnit.customsGoods &&
          (__props.order.loadUnit.dangerousGoods ||
            __props.order.loadUnit.waste ||
            __props.order.loadUnit.limitedQuantity)
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_db_icon, {
                    icon: "info",
                    variant: "24-outline"
                  }),
                  (__props.order.loadUnit.dangerousGoods)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.dangerous_goods"),
            })), 1))
                    : _createCommentVNode("", true),
                  (__props.order.loadUnit.waste)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.waste"),
            })), 1))
                    : _createCommentVNode("", true),
                  (__props.order.loadUnit.limitedQuantity)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("order.error_customs_with_dangerous", {
              type: _ctx.$t("order.limitedQuantity"),
            })), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (__props.order.loadUnit.customsGoods)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_db_icon, {
                      icon: "info",
                      variant: "24-outline"
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("order.error_customs")), 1)
                  ])
                ]))
              : (
          __props.order.loadUnit.dangerousGoods ||
          __props.order.loadUnit.waste ||
          __props.order.loadUnit.limitedQuantity
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_db_icon, {
                        icon: "info",
                        variant: "24-outline"
                      }),
                      (__props.order.loadUnit.dangerousGoods)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.dangerous_goods") })), 1))
                        : _createCommentVNode("", true),
                      (__props.order.loadUnit.waste)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.waste") })), 1))
                        : _createCommentVNode("", true),
                      (__props.order.loadUnit.limitedQuantity)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t("order.error_goods", { type: _ctx.$t("order.limitedQuantity") })), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
        ], 2),
        (__props.order.transportationStatus === _unref(COUNTER_CANCELLATION_NEEDED))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_MyTravel, { color: "red" }),
                _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("tour.counter_cancellation_needed")), 1)
              ])
            ]))
          : (__props.activeOrder == null || showTrainInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(ElectricLocomotive, { onClick: toggleTrainInfo }),
                  _createTextVNode(_toDisplayString(__props.order.train.trainNumber), 1)
                ]),
                (!showTrainInfo.value)
                  ? (_openBlock(), _createBlock(StatusChangeButton, {
                      key: 0,
                      order: __props.order,
                      index: __props.index,
                      classList: "hydrated mt-2 px-2",
                      variant: "primary",
                      disabled: statusChangeButtonDisabled()
                    }, null, 8, ["order", "index", "disabled"]))
                  : _createCommentVNode("", true)
              ]))
            : (__props.order)
              ? (_openBlock(), _createBlock(OrderDetails, {
                  key: 2,
                  onClose: _cache[0] || (_cache[0] = ($event: any) => (toggleOrder())),
                  onRefreshData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refreshData'))),
                  order: __props.order,
                  index: __props.index
                }, null, 8, ["order", "index"]))
              : _createCommentVNode("", true),
        (showTrainInfo.value)
          ? (_openBlock(), _createBlock(OrderTrainInfo, {
              key: 3,
              onClose: toggleTrainInfo,
              order: __props.order
            }, null, 8, ["order"]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})